module.exports = __webpack_public_path__ + "img/diaspora.png";